
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'reader' | 'journalist' | 'admin';
  requiredRoles?: Array<'reader' | 'journalist' | 'admin'>;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole,
  requiredRoles
}) => {
  const { user, userProfile, isLoading } = useAuth();
  const location = useLocation();
  
  // Combine requiredRole and requiredRoles for backward compatibility
  const allRequiredRoles = requiredRoles || (requiredRole ? [requiredRole] : []);

  // Show a loading state if we're still checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // If no user is logged in, redirect to login page
  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Get the user's role from user profile or metadata
  const userRole = userProfile?.user_role || user.user_metadata?.user_role;

  console.log('ProtectedRoute - User role:', userRole);
  console.log('ProtectedRoute - Required roles:', allRequiredRoles);

  // If specific roles are required, check user role
  if (allRequiredRoles.length > 0) {
    if (userRole === 'journalist' || userRole === 'admin') {
      // Journalists and admins can access both journalist and reader routes
      console.log('ProtectedRoute - Access granted (journalist/admin)');
      return <>{children}</>;
    } else if (!allRequiredRoles.includes(userRole as any)) {
      // Redirect users who don't have the required role
      const redirectPath = userRole === 'journalist' 
        ? '/dashboard' 
        : '/home';
      
      console.log('ProtectedRoute - Access denied, redirecting to:', redirectPath);
      return <Navigate to={redirectPath} replace />;
    }
  }

  // User is authenticated and has the required role (or is a journalist accessing reader content)
  console.log('ProtectedRoute - Access granted');
  return <>{children}</>;
};

export default ProtectedRoute;
